import React from "react";
import { Skeleton } from "@material-ui/lab";
export var ButtonSkeleton = function () { return React.createElement(Skeleton, { height: 50, width: 150 }); };
